import { useState } from "react";
import { Button, Card, Flex, Form, Input, message } from "antd";
import JAS_LOGO from "../assets/JAS_LOGO.avif";

const SignUp = () => {
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = (values) => {
    const { name, email, company } = values;

    const subject = encodeURIComponent("New Integration Lead – JAS Communications Zoho CRM");
    const body = encodeURIComponent(
      `Hello JAS Sales Team,\n\nA new lead has submitted a signup request from the Zoho CRM integration page.\n\nName: ${name}\nEmail: ${email}\nCompany: ${company}\n\nPlease follow up with them at your earliest convenience.\n\nThis email was sent automatically from the JAS Communications Zoho integration landing page.`
    );

    window.location.href = `mailto:sales@jascommunications.com?subject=${subject}&body=${body}`;
    setSubmitted(true);
  };

  return (
    <Flex
      align="center"
      justify="center"
      vertical
      style={{ minHeight: "100dvh", backgroundColor: "#0b1120", padding: "2rem" }}
    >
      <a href="/" style={{ marginBottom: "2rem" }}>
        <img
          src={JAS_LOGO}
          alt="JAS Communications Logo"
          style={{ height: 52, display: "block" }}
        />
      </a>

      <Card
        style={{
          width: "100%",
          maxWidth: "480px",
          backgroundColor: "#1a2236",
          border: "1px solid #1e2d45",
          borderRadius: "12px",
          color: "#f0f4ff",
        }}
      >
        {!submitted ? (
          <>
            <h2 style={{ textAlign: "center", color: "#ffffff", marginBottom: "0.5rem" }}>
              Get Started with JAS
            </h2>
            <p style={{ textAlign: "center", color: "#94a3b8", marginBottom: "1.5rem", fontSize: "0.9rem" }}>
              Interested in integrating JAS Communications with Zoho CRM? Fill in your details and our team will be in touch.
            </p>

            <Form layout="vertical" onFinish={onSubmit} requiredMark={false}>
              <Form.Item
                label={<span style={{ color: "#94a3b8" }}>Full Name</span>}
                name="name"
                rules={[{ required: true, message: "Please enter your name" }]}
              >
                <Input
                  placeholder="Jane Smith"
                  style={{ backgroundColor: "#0b1120", borderColor: "#1e2d45", color: "#f0f4ff" }}
                />
              </Form.Item>

              <Form.Item
                label={<span style={{ color: "#94a3b8" }}>Work Email</span>}
                name="email"
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <Input
                  placeholder="jane@company.com"
                  style={{ backgroundColor: "#0b1120", borderColor: "#1e2d45", color: "#f0f4ff" }}
                />
              </Form.Item>

              <Form.Item
                label={<span style={{ color: "#94a3b8" }}>Company Name</span>}
                name="company"
                rules={[{ required: true, message: "Please enter your company name" }]}
              >
                <Input
                  placeholder="Acme Insurance Brokerage"
                  style={{ backgroundColor: "#0b1120", borderColor: "#1e2d45", color: "#f0f4ff" }}
                />
              </Form.Item>

              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  style={{
                    backgroundColor: "#2563eb",
                    borderColor: "#2563eb",
                    fontWeight: 600,
                    height: "42px",
                    borderRadius: "6px",
                  }}
                >
                  Request Access
                </Button>
              </Form.Item>
            </Form>
          </>
        ) : (
          <Flex vertical align="center" gap={16} style={{ padding: "2rem 0" }}>
            <span style={{ fontSize: "3rem" }}>✅</span>
            <h2 style={{ color: "#ffffff", textAlign: "center", margin: 0 }}>
              We'll Be in Touch!
            </h2>
            <p style={{ color: "#94a3b8", textAlign: "center", fontSize: "0.9rem" }}>
              Thanks for your interest in JAS Communications. Our sales team will reach out to you shortly at <strong style={{ color: "#60a5fa" }}>sales@jascommunications.com</strong>.
            </p>
          </Flex>
        )}
      </Card>
    </Flex>
  );
};

export default SignUp;
